import { render, staticRenderFns } from "./ClrmTabsStudent.vue?vue&type=template&id=72c8b756&scoped=true&"
import script from "./ClrmTabsStudent.vue?vue&type=script&lang=js&"
export * from "./ClrmTabsStudent.vue?vue&type=script&lang=js&"
import style0 from "./ClrmTabsStudent.vue?vue&type=style&index=0&id=72c8b756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c8b756",
  null
  
)

export default component.exports